module.exports = __webpack_public_path__ + "img/sculpt4_thumb.be256a0a.jpg";